import { FieldType, Model, Schema } from "@core/index";

export interface IAirCheckinRequest {
    flightNumber?: string;
    passengerId?: string;
    referenceId?: string;
}

export class AirCheckinRequest extends Model implements IAirCheckinRequest {
    public static schema: Schema = new Schema("CheckinInfoRequest");
    public flightNumber?: string;
    public passengerId?: string;
    public referenceId?: string;

    constructor(values: IAirCheckinRequest) {
        super(AirCheckinRequest.schema);
        this.setValues(values);
    }
}

AirCheckinRequest.schema.addField("flightNumber").type(FieldType.FlightNumber).required();
AirCheckinRequest.schema.addField("passengerId").type(FieldType.String);
AirCheckinRequest.schema.addField("referenceId").type(FieldType.String).required().pattern(/^(\d{8}|\d{13})$/);